module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3AiMv"))).then(() => parcelRequire('d0iPb'));